import type { User } from '@shared/types/users';
import { parseAddress } from 'library/helpers/events/address';
import { getEventDaysHours } from 'library/helpers/events/dateSets';
// import { getDiscountEventInfo } from 'library/helpers/events/discount';
import type { Event } from 'library/models/events';
import * as st from './styles.module.scss';
import { EventDateTime } from './ui/event-date-time';
import { ItemInfo } from './ui/item-info';
// import { ItemPromotion } from './ui/item-promotion';
import { Person } from './ui/person';

interface Props {
  eventInfo: Event;
  person?: User;
}

export const EventInfo = ({ eventInfo, person }: Props): JSX.Element => {
  const { mode, address, timetable, places, cost, title, refusal, prepayment_cost } = eventInfo;

  const place = mode === 'N' ? 'Онлайн' : `${parseAddress(address)}`;
  const [days, hours] = getEventDaysHours(timetable);
  const hasDateStages = timetable.length > 1;
  //Discount убрали
  // const promotion = getDiscountEventInfo(discount);

  return (
    <div className={st.info}>
      <div className={st.info__head}>
        <span className={st.title}>Участник</span>
        <Person person={person} />
      </div>
      <div className={st.info__body}>
        <ul className={st.list}>
          <ItemInfo title="Название" value={title} />
          <ItemInfo title="Место встречи" value={place} />
          <ItemInfo title="Часовой пояс" value={'GMT+3 МСК'} />

          {hasDateStages ? (
            <>
              <ItemInfo title={'Дата/время'} />
              {timetable.map((timeTable, index) => (
                <ItemInfo
                  key={index}
                  title={`Этап ${index + 1}`}
                  value={
                    <EventDateTime
                      date={timeTable.date}
                      timeRange={`${timeTable.time_from} - ${timeTable.time_to}`}
                    />
                  }
                />
              ))}
            </>
          ) : (
            <ItemInfo
              title={'Дата/время'}
              value={
                <EventDateTime
                  date={timetable[0].date}
                  timeRange={`${timetable[0].time_from} - ${timetable[0].time_to}`}
                />
              }
            />
          )}

          {!!days && days > 1 && <ItemInfo title="Кол-во дней" value={days} />}
          {!!hours && <ItemInfo title="Кол-во часов" value={hours} />}
          {refusal > 0 && (
            <ItemInfo
              title="Отменить"
              value={refusal}
              description="Время за которое вы можеье отказаться от участия в мероприятии с возвратом оплаченной суммы"
            />
          )}
          <ItemInfo title="Язык" value={'Русский'} />
          {places && <ItemInfo title="Осталось мест" value={places} />}
          <ItemInfo title="Стоимость" value={cost === 0 ? 'Бесплатно' : `${cost / 100} RUB`} />
          {prepayment_cost > 0 && (
            <ItemInfo title="Предоплата" value={`${prepayment_cost / 100} RUB`} />
          )}
          {/* {promotion && (
            <ItemPromotion
              title="Акция"
              value={`${promotion.discountCost} RUB до ${promotion.discountTo}`}
            />
          )} */}
        </ul>
      </div>
    </div>
  );
};
